<div class="background" *ngIf="show" (click)="handleBackground()">
  <section [ngStyle]="getPosition()">
    <div *ngFor="let item of items" (click)="handleClick(item)">
      {{ item.label }}
    </div>
  </section>
</div>
